module.exports = __webpack_public_path__ + "img/pic_7.1c62de51.jpg";